import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { getCliente } from "../../services/ClientesService";
import BreadcrumbCRM from "./BreadcrumbCRM";
import { Col, Row, Button, InputGroup, Form, Modal, Table } from "react-bootstrap";
import { getHistorial, getHistorialPorMarca } from "../../services/CRMService";
import MaoTable from "../common/MaoTable";
import { useNavigate } from "react-router-dom";
import { getMesFromNumero, getAnioActual } from "../../utils/DateUtils";
import { formatNumber } from "../../utils/NumberUtils";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { AnioSelect } from "../common/AnioSelect";
import { useForm } from "react-hook-form";
import ReporteEvolucionVentasCRMChartJS from "./ReporteEvolucionVentasCRMChartJS";

export default function Historial() {

    const {id} = useParams();
    const {register} = useForm();
    const navigate = useNavigate();

    const [errores, setErrores] = useState([]);
    
    const [datos, setDatos] = useState([]);
    const [totales, setTotales] = useState({});
    const [cliente, setCliente] = useState({});
    const [anioEnCurso, setAnioEnCurso] = useState(true);
    const [columnas, setColumnas] = useState([]);
    const [anio, setAnio] = useState(getAnioActual())

    const [mesModal, setMesModal] = useState("");
    const [detallePorMarca, setDetallePorMarca] = useState([]);

    const [mostrarGraficas, setmostrarGraficas] = useState(false);
    const [moneda, setMoneda] = useState(false);

    const handleClose = () => {
        setDetallePorMarca([]);
        setMesModal("");
    }

    async function masInfo(mes) {
        let montoEnDolaresParam =
            document.getElementById(
                'chkMostrarMontoEnDolares'
            ).checked;
        let resp = await getHistorialPorMarca(id, anio, mes, montoEnDolaresParam);
        if (resp.error) {
            setErrores([resp.message]);
        } else {
            if (resp.data.length>0) {
                setDetallePorMarca(resp.data);
                setMesModal(getMesFromNumero(parseInt(mes),false));
            } else {
                alert("no hay datos para mostrar");
            }
        }

    }

    console.log('entra a historial');


    async function determinarColumnas(anioEnCurso, montoEnDolares) {
        console.log(`Va a armar columnas con anioEnCurso=${anio}`);
        if (anioEnCurso) {
            let newColumnas = [];
            if (window.innerWidth>=992) {//En resolucion lg
                newColumnas.push({
                    //titulo: getAnioActual(),
                    titulo : <AnioSelect 
                        register = {register} 
                        value={anio}
                        name="anio"
                        onChange={e=> {
                            setAnio(e.target.value)
                            //actualizar()
                        }}
                    />,
                    atributo:"titulo"
                });
                for (let i=1;i<=12;i++) {
                    newColumnas.push({
                        titulo:getMesFromNumero(i),
                        atributo:`${i}`,
                        className:"col-importe"
                    });
                }
                newColumnas.push({
                    titulo:"Total",
                    atributo:"total",
                    className:"col-importe col-bold"
                });
            } else { //resolución menor a lg
                newColumnas = [
                    {
                        titulo:"Mes",
                        atributo:"mesEnLetras"
                    },
                    {
                        titulo:"Cant. Pedidos",
                        atributo: "cantidad",
                        className:"col-importe"
                    },
                    {
                        titulo:`Total ${montoEnDolares ? 'USD' : '$'}`,
                        atributo:"total",
                        className:"col-importe",
                        funcion: formatNumber
                    },
                    {
                        titulo:`Comisiones ${montoEnDolares ? 'USD' : '$'}`,
                        atributo:"comisiones",
                        className:"col-importe",
                        funcion: formatNumber
                    }
                ];
            }
            setColumnas(newColumnas);
        }
    }

    useEffect(()=> {
        determinarColumnas(anio, false);
        actualizarDatos()
    }, [anio]);

    useEffect(() => {
        const iniciar = async () => {
            setDatos([]);
            let resp = await getCliente(id);
            if (resp.error) {
                setErrores([resp.message]);
            } else {
                setCliente(resp.data);
                actualizar(id);
            }
        }
        if (id) {
            iniciar();
        }
    }, [id])

    async function actualizarDatos() {
        actualizar(id);
    }

    async function actualizar(id_cliente) {
        let montoEnDolaresParam =
            document.getElementById(
                'chkMostrarMontoEnDolares'
            ).checked;
        let horizontal = window.innerWidth>=992;
        let resp2 = await getHistorial(id_cliente, anio, horizontal, montoEnDolaresParam);
        console.log(resp2);
        if (resp2.error) {
            let erroresNew = errores.slice(0);
            erroresNew.push(resp2.message);
            setErrores(erroresNew);
        } else {
            determinarColumnas(anioEnCurso, montoEnDolaresParam);
            let total_cantidad = 0;
            let total_total = 0;
            let total_comisiones = 0;
            if (horizontal) {
                for (let i=1;i<=12;i++) {
                    total_cantidad += parseInt(resp2.data[0][`${i}`]);
                    total_total += parseFloat(resp2.data[1][`${i}`]);
                    resp2.data[1][`${i}`] = formatNumber(parseFloat(resp2.data[1][`${i}`]));
                    total_comisiones += parseFloat(resp2.data[2][`${i}`]);
                    resp2.data[2][`${i}`] = formatNumber(parseFloat(resp2.data[2][`${i}`]));
                }
                resp2.data[0].total = total_cantidad;
                resp2.data[1].total = formatNumber(total_total);
                resp2.data[2].total = formatNumber(total_comisiones);
                //setTotales(undefined);
                let totales = [];
                for (let i=0;i<=12;i++) {
                    let col = <Button size="sm" title="Mas Info" onClick={() => {masInfo(i)}}>
                                <FaMagnifyingGlass />
                            </Button>;
                    totales.push(col);
                }
                setTotales(totales);
            } else {
                for (let i=0;i<resp2.data.length;i++) {
                    total_cantidad += parseInt(resp2.data[i].cantidad);
                    total_total += parseFloat(resp2.data[i].total);
                    total_comisiones += parseFloat(resp2.data[i].comisiones);
                    resp2.data[i].mesEnLetras = getMesFromNumero(parseInt(resp2.data[i].mes));
                }
                setTotales({
                    mesEnLetras:"Total",
                    cantidad: total_cantidad,
                    total: formatNumber(total_total),
                    comisiones: formatNumber(total_comisiones)
                })
            }
            setDatos(resp2.data);
            setmostrarGraficas(true);
        }
    }

    function volver () {
        navigate("/crm/clientes");
    }

    return <>
        <BreadcrumbCRM active="Historial de Pedidos" />
        <Form>
            <Row className="align-items-center">
                <Col xs="auto" md="6">
                <InputGroup className="mb-2">
                <Form.Label htmlFor="inlineFormInput" visuallyHidden>
                    Nombre
                </Form.Label>
                <Form.Control
                    id="txtCliente" 
                    value={cliente?.nombre_razon_social}
                    disabled={true}
                />
                <Button id="btnActualizar"onClick={actualizarDatos} >
                    Actualizar
                </Button>
                <div className="d-flex align-items-center ms-2">
                    <Form.Check
                        type="checkbox"
                        id="chkMostrarMontoEnDolares"
                        className="me-0"
                        label=""
                        onClick={actualizarDatos}
                        onChange={(e) => setMoneda(e.target.checked)}
                    />
                    <label htmlFor="chkMostrarMontoEnDolares" className="ms-0">
                        Mostrar monto en dólares
                    </label>
                </div>
                </InputGroup>
                </Col>
            </Row>
        </Form>
        {columnas.length==4?
        <MaoTable 
            columnas={columnas} 
            datos={datos} 
            colId="mes"
            totales={totales}
            otrasAcciones={[
                {title:"Más Info", icon:<FaMagnifyingGlass />, click: masInfo},
            ]}>
        </MaoTable>:
        <MaoTable 
            columnas={columnas} 
            datos={datos} 
            colId="mes"
            totales={totales}>
        </MaoTable>}
            
        { mostrarGraficas ? 
            <ReporteEvolucionVentasCRMChartJS ventas={datos} titulos={columnas} moneda={moneda}/> : 
            <div className="error" >Presione Actualizar para ver el gráfico</div>
        }
        <div className="d-flex justify-content-center">
            <Button onClick={volver}>Volver</Button>
        </div>
        <Modal show={mesModal!==''} onHide={handleClose} size="lg">
            <Modal.Header closeButton style={{backgroundColor: '#212529', color: 'white'}}>
            <Modal.Title>Detalle por Marca - {mesModal}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{backgroundColor: '#212529'}}>
                <Table striped bordered hover responsive variant="dark" size="sm">
                    <thead>
                        <tr>
                            <th>Marca</th>
                            <th className="col-importe">Cantidad</th>
                            <th className="col-importe">Monto</th>
                            <th className="col-importe">Comisiones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {detallePorMarca.map((m,index) => <tr key={index} style={{padding: 0}}>
                            <td>{m.nombre_marca}</td>
                            <td className="col-importe">{m.cantidad}</td>
                            <td className="col-importe">{formatNumber(m.total)}</td>
                            <td className="col-importe">{formatNumber(m.comisiones)}</td>
                        </tr>)}
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer style={{backgroundColor: '#212529'}}>
            <Button variant="secondary" onClick={handleClose}>
                Cerrar
            </Button>
            </Modal.Footer>
        </Modal>
    </>

}